import React, { useState, useEffect } from "react";
import { FaAngleUp } from "react-icons/fa";
import "./ScrollToTop.scss";

const ScrollToTop = () => {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    if (typeof window !== "undefined") {
      document.addEventListener("scroll", function (e) {
        toggleVisibility();
      });
    }
  }, []);

  const scrollToTop = () => {
    if (typeof window !== "undefined") {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  };

  const toggleVisibility = () => {
    if (typeof window !== "undefined" && window.pageYOffset > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };
  return (
    <React.Fragment>
      {isVisible ? (
        <div className="scrollToTop" onClick={scrollToTop}>
          <FaAngleUp className="scrollToTopIcon" />
        </div>
      ) : null}
    </React.Fragment>
  );
};

export default React.memo(ScrollToTop);
